import React from 'react';
import { setCookie } from 'nookies';
import cc from 'classcat';
import styles from './cookieBanner.module.sass';
import { isNewYear } from '../../utils/isBlackFridayCheck';

export const CookieBanner = ({ onOpen, timeToCookie, isTablet, isMobile }) => {
  const closeBanner = () => {
    onOpen(true);
  };

  return (
    <>
      {isMobile ? (
        <div
          className={cc([
            [styles.wrapperMobile],
            {
              [styles.wrapperTablet]: isTablet,
            },
          ])}
        >
          <a
            className={styles.textBlock}
            href={
              isNewYear() ? '/novogodniy-keshbek-za-pokupku-kruizov' : '/2025'
            }
          >
            {isNewYear() ? (
              <div className={styles.text}>
                Выигрывайте новогодний кешбэк до 20%
              </div>
            ) : (
              <div className={styles.text}>
                Круизы на 2026 год со скидками раннего бронирования до 15%!
              </div>
            )}
          </a>
          <button
            className={styles.closeButtonMobile}
            onClick={() => [
              setCookie(null, 'closeBanner', 'true'),
              closeBanner(),
              setCookie(null, 'timeToOpenBanner', timeToCookie),
            ]}
          >
            {' '}
          </button>
        </div>
      ) : (
        <div
          className={cc([
            [styles.wrapper],
            {
              [styles.wrapperTablet]: isTablet,
            },
          ])}
        >
          <div className={styles.textBlock}>
            {isNewYear() ? (
              <div className={styles.text}>
                Выигрывайте новогодний кешбэк до 20%
              </div>
            ) : (
              <div className={styles.text}>
                Круизы на 2026 год со скидками раннего бронирования до 15%!
              </div>
            )}

            <a
              href={
                isNewYear() ? '/novogodniy-keshbek-za-pokupku-kruizov' : '/2026'
              }
              className={styles.insideButton}
            >
              {isNewYear() ? 'Перейти' : 'Хочу'}
            </a>
          </div>
          <button
            className={styles.closeButton}
            onClick={() => [
              setCookie(null, 'closeBanner', 'true'),
              closeBanner(),
              setCookie(null, 'timeToOpenBanner', timeToCookie),
            ]}
          >
            {' '}
          </button>
        </div>
      )}
    </>
  );
};
